import { render, staticRenderFns } from "./FolderSelecton.vue?vue&type=template&id=1927b766&"
import script from "./FolderSelecton.vue?vue&type=script&lang=js&"
export * from "./FolderSelecton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports